export default __webpack_public_path__ + "static/thumbnail-fcdda6424b337fc5830473eced9d16dc.png";